module.exports = __webpack_public_path__ + "static/img/17dd824c_8ebc_428c_b6e5_3a87c1b0fd02.4a7aa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/17dd824c_8ebc_428c_b6e5_3a87c1b0fd02.jpg
// module id = 8CXz
// module chunks = 0